<template>
  <div class="protocol">
    <el-dialog :visible.sync="protocol.visible" 
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               title="《美团收银服务协议》《隐私政策》更新通知">
      <ul>
        <li>
          <div class="content">尊敬的商家：</div>
        </li>
        <li>
          <div class="content">
            感谢您信任并使用智能收银系统服务。依据最新法律要求，我们更新了《美团收银服务协议》及《隐私政策》，并根据您使用服务的具体功能对您的个人信息进行收集、使用和共享。
            请您仔细阅读《美团收银服务协议》及《隐私政策》，并确认了解我们对您提供的服务以及对您个人信息处理原则。
          </div>
        </li>
        <li>
          <div class="content">如您同意
            <a href="javascript:;" @click="openAgreementDialog">《美团收银服务协议》</a>及
            <a href="javascript:;" @click="openPrivacyDialog">《隐私政策》</a>
            ，请点击“同意”后使用我们的产品和服务，我们依法尽全力向您提供服务并保护您的个人信息。
            </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDisagree">不同意</el-button>
        <el-button type="primary" @click="handleAgree">同意</el-button>
      </span>
    </el-dialog>
    <agreement-dialog ref="agreement"></agreement-dialog>
    <privacy-dialog ref="privacy"></privacy-dialog>
    <warning-dialog :warning="warning" :warningCount="warningCount"></warning-dialog>
  </div>
</template>
<script>
  import AgreementDialog from './Agreement.vue';
  import PrivacyDialog from './Privacy.vue';
  import WarningDialog from './Warning.vue';
  export default {
    props: ['protocol'],
    components: {
      AgreementDialog,
      PrivacyDialog,
      WarningDialog
    },
    data () {
      return {
        isFirst: true,
        agreement: {
          visible: false
        },
        privacy: {
          visible: false
        },
        warning: {
          visible: false
        },
        warningCount: 1
      };
    },
    methods: {
      handleDisagree () { //不同意
        if (this.isFirst) {
          this.warning.visible = true;
          this.isFirst = false;
          this.warningCount = 1;
        } else {
          this.warning.visible = true;
          this.warningCount = 2;
        }
      },
      handleAgree () { //同意
        this.$axios.post('/hq-agency/agreement/agency/sign').then((res) => {
          if (res.code === 200) {
            this.protocol.visible = false;
            LXAnalytics && LXAnalytics('moduleClick', 'b_eco_2nvzn1h4_mc');
          } else {
            this.$message.error("网络异常，请稍后再试");
          }
        });
      },
      openAgreementDialog () {
        this.$refs.agreement.handleShow();
        LXAnalytics && LXAnalytics('moduleClick', 'b_eco_nopl0xx0_mc');
      },
      openPrivacyDialog () {
        this.$refs.privacy.handleShow();
        LXAnalytics && LXAnalytics('moduleClick', 'b_eco_tvm27u19_mc');
      },
    }
  };
</script>
<style lang="less">
  .protocol {
    .el-dialog {
      max-height: 500px;
      .el-dialog__body {
        overflow-y: scroll;
      }
    }
    .el-dialog__body {
      overflow: hidden;
      font-size: 12px;
      color: #333333;
      max-height: 328px;
      .title {
        font-weight: bolder;
        padding: 20px 0;
      }
      .content {
        text-indent: 2em;
        p {
          padding-bottom: 15px;
        }
      }
    }
    li {
      line-height: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// Protocol.vue?723b7932